export const reloadThePage = () => {
  window.location.reload();
};
export const WAITING_PAGE = 'extras_waiting_page';

export const GOBACK_EVENT = {
  action: 'shopping_basket_payment_modal',
  category: 'shopping_basket_payment',
  label: 'error_clicks_button_go_back',
};

export const RETRY_EVENT = {
  action: 'shopping_basket_payment_modal',
  category: 'shopping_basket_payment',
  label: 'error_clicks_button_try_again',
};
